import { render, staticRenderFns } from "./StudentMidtermgrades.vue?vue&type=template&id=3a6db40a"
import script from "./StudentMidtermgrades.vue?vue&type=script&lang=js"
export * from "./StudentMidtermgrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports